import { makeStyles, Typography } from "@material-ui/core";
import { Link } from "react-router-dom";
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import LoadingShort from "../../load/loadingShort";
import { useSelector } from "react-redux";
import IniciaisLetras from "../../utils/iniciaisLetras";

const useStyles = makeStyles((theme) => ({
    root: {
        position: 'relative',
        textAlign: 'center',
        width: '17%',
        height: 200,
        minWidth: 130,
        // backgroundColor: '#fff',
        border: '1px solid #85287e',
        borderRadius: 10,
        transition: '.5s',
        '&:hover': { background: '#85287d8a', },

        [theme.breakpoints.down('xs')]: { width: '100%' },
    },
    icone: {
        transition: '.5s',
        '&:hover': { height: 85 },
        height: 80,
        margin: 'auto'
    }
}))

type cardServicesProps = {
    icone?: string;
    nomeService: string;
    link: string;
    count: number | null;
    load?: boolean;
    funcao?: string;
    disabled?: boolean;
    title?: string;
}

interface User {
    tipo: string;
    membro: string;
    title?: string;
    funcao?: string;
}

interface RootState {
    account: {
        user: User
    };
}


export default function CardServices({ icone, nomeService, link, count, load, funcao, title, disabled = false }: cardServicesProps) {
    const classes = useStyles();
    const user = useSelector((state: RootState) => state.account.user);

    return (
        <CardActionArea
            title={title}
            className={classes.root}
            style={{ background: funcao === user.funcao ? '#85287d8a' : '' }}
            disabled={disabled}

        >
            <Link style={{ textDecoration: 'none' }} to={link}>
                <CardContent>
                    {icone ?
                        <div style={{ height: 70 }}>
                            <img src={icone} alt={''} className={classes.icone} />
                        </div>
                        :
                        <Typography align="center" color="textSecondary" variant="h3" >
                            <IniciaisLetras frase={nomeService} />
                        </Typography>
                    }
                </CardContent>

                <CardContent style={{ padding: 8 }}>
                    <Typography color="textPrimary" variant="subtitle1" style={{ lineHeight: 1.3, fontSize: 16 }}>
                        {nomeService}
                    </Typography>
                </CardContent>

                <br />
                <CardContent style={{ padding: 0, position: 'absolute', bottom: 0, width: '100%' }}>
                    {load ?
                        <LoadingShort text={''} />
                        :
                        <Typography align="center" color="initial" variant="subtitle1" style={{ fontSize: 20, fontWeight: 'bold' }}>
                            {count}
                        </Typography>
                    }
                </CardContent>
            </Link>
        </CardActionArea>
    )
}